export default __webpack_public_path__ + "static/media/global-icon-one-hover.74089bdc.png";